/*=============================================== Cover ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React, { Suspense } from "react";
import styled, { css } from "styled-components";
import Variables from "../Variables";
import Mixins from "../Mixins";
import Fallback from "../Fallback";
var CoverImage = React.lazy(function () { return import("./CoverImage"); });
/*==================== Styles ====================*/
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    width: 100%;\n    height: 100vh;\n\n    ", "\n"], ["\n    position: relative;\n    width: 100%;\n    height: 100vh;\n\n    ", "\n"])), function (_a) {
    var $overlay = _a.$overlay;
    return $overlay && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            &:before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: 1;\n                width: 100%;\n                height: 100%;\n                background-color: ", ";\n            }\n        "], ["\n            &:before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                left: 0;\n                z-index: 1;\n                width: 100%;\n                height: 100%;\n                background-color: ", ";\n            }\n        "])), Variables.Overlays.Plain.Black50);
});
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    color: ", ";\n    width: 100%;\n    height: 100%;\n    ", ";\n    padding: ", " 5%;\n    text-align: ", ";\n\n    & > * {\n        position: relative;\n        top: 0;\n    }\n"], ["\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 2;\n    color: ", ";\n    width: 100%;\n    height: 100%;\n    ", ";\n    padding: ", " 5%;\n    text-align: ", ";\n\n    & > * {\n        position: relative;\n        top: 0;\n    }\n"
    /*==================== Component ====================*/
])), Variables.Colors.White, function (_a) {
    var $align = _a.$align;
    return Mixins.Flexbox({
        $align: $align === "bottom" ? "flex-start" : "center",
        $justify: $align === "bottom" ? "flex-end" : "center",
        $direction: "column",
        $gap: "s",
    });
}, Variables.Spacers.XXL, function (_a) {
    var $align = _a.$align;
    return $align === "center" && "center";
});
/*==================== Component ====================*/
var Cover = function (_a) {
    var src = _a.src, alt = _a.alt, children = _a.children, overlay = _a.overlay, _b = _a.align, align = _b === void 0 ? "center" : _b, props = __rest(_a, ["src", "alt", "children", "overlay", "align"]);
    return (React.createElement(Container, __assign({ "$overlay": overlay, "$align": align }, props),
        React.createElement(Suspense, { fallback: React.createElement(Fallback, { "$width": "100%", "$height": "100vh" }) },
            React.createElement(CoverImage, { src: src, alt: alt })),
        React.createElement(Content, { "$align": align }, children)));
};
export default Cover;
/*==================== Types ====================*/
var align = {
    center: "center",
    bottom: "bottom",
};
var templateObject_1, templateObject_2, templateObject_3;
